import React from 'react';
import {createRoot} from 'react-dom';
import './index.css';
import Login from './Login.js';
import App from './App.js';
import Schedule from './schedule.js';
import QRCodeGenerator from './qr.js';
import Gyogik from './Gyogik.js';
import Gyogik_info from './Gyogik_info.js';
import GyogikSearch from './Gyogik_search.js'; // gyogik_search.js 대신 컴포넌트로 대체
import Grade from './grade.js';   // 학생 성적조회 
import Test from './Test.js'; // test.js 대신 컴포넌트로 대체
import Tell from './Tell.js';
import Tell_info from './tell_info.js';
import Qr_Check from './Qr_Check.js';
import {BrowserRouter, Routes, Route} from 'react-router-dom';
import Setting from './setting.js'
import BottomNav from './bottom_navy.js';
import reportWebVitals from './reportWebVitals';
import ScholarPage from "./scholar";

const root = createRoot(document.getElementById('root'));
root.render(
    <React.StrictMode>
        <BrowserRouter>
            <Routes>
                <Route path="/Login" element={<Login/>}/>
                <Route path="/" element={<App/>}/>
                <Route path="/schedule" element={<Schedule/>}/>
                <Route path="/qr" element={<QRCodeGenerator/>}/>
                <Route path="/Gyogik" element={<Gyogik/>}/>
                <Route path="/Gyogik_info/:variable1/:variable2" element={<Gyogik_info/>}/>
                <Route path="/Gyogik_search" element={<GyogikSearch/>}/>
                <Route path="/Grade" element={<Grade/>}/>
                <Route path="/Test" element={<Test/>}/>
                <Route path="/Tell" element={<Tell/>}/>
                <Route path="/Tell_info/:variable3/:variable4" element={<Tell_info/>}/>
                <Route path="/Qr_Check" element={<Qr_Check/>}/>
                <Route path="/setting" element={<Setting/>}/>
                <Route path="/scholar" element={<ScholarPage/>}/>
            </Routes>
            <BottomNav/>
        </BrowserRouter>
    </React.StrictMode>
);

reportWebVitals();
